const home = {
  totalNumber: "人员总数",
  searchTip: '请输入姓名/设备编号/主机编号',
  online: '在线',
  offline: '离线',
  all: '全部',
  alarm: '告警',
  allPerson: '所有人员',
  bindWatch: '已绑表',
  unbindWatch: '未绑表',
  tree: '树形结构',
  list: '列表清单',
  loadMore: '加载更多...',
  statu: '状态',
  command: '指令',
  sendUnlockCommand: '下发开锁指令',
  sendCommandToUseWearCheck: '下发开启佩戴检测指令',
  sendCommandToNonuseseWearCheck: '下发关闭佩戴检测指令',
  useWearCheck: '佩戴检测(已启用)',
  nonuseWearCheck: '佩戴检测(未启用)',
  location: '位置',
  sendLocationCommand: '下发定位指令',
  time: '更新时间',
  noData: '无数据',
  step: '步',
  stepNumber:'步数',
  temperature:'温度',
  bodyTemperature:'体温',
  systolicPressure:'收缩压',
  diastolicPressure:'舒张压',
  vitalSigns:'生命体征',
  sendCommandToInstantHeartRate: '下发测量心率指令',
  beatPerMin: '次/分',
  info: '详情',
  track: '轨迹',
  health: '健康',
  alarms: '告警',
  hook: '事件',
  noLocationTip: '当前人员没有位置信息',
  noLocationDescription: '已下发定位命令，请在1分钟后重试！',
  requestTimeOut: '当前网络延迟较大，已切换到后台执行！',
  sendCommandSuccess: '下发命令成功',
  heartRataSuccess: '心率测量成功',
  locationSuccess: '定位成功',
  sendUnlockSuccess: '下发开锁指令成功',
  heartRateFailed: '心率测量失败',
  commandFailed: '命令执行失败',
  personInfo: '详情',
  deviceInfo: '设备',
  heartRate: '心率',
  noPosition: '未获取到',
  weared: '已佩戴',
  nonWeared: '未佩戴',
  age: '岁',
  globalView: '全局视图',
  showNames: '显示人员姓名',
  hideNames: '隐藏人员姓名',
  showOrgFences: '显示机构围栏',
  hideOrgFences: '隐藏机构围栏',
  checkGroupTitle: '请选择要显示的围栏组',
  checkAll: '全选',
  pleaseSelectAScene:"请选择场景",
  bloodOxygen: '血氧',
  bloodPressure: '血压',
  latitudeLongitude: '经纬度',
}
export default home